import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { FormControl, ReactiveFormsModule, ValidatorFn } from "@angular/forms";
import { Observable } from "rxjs";
import {
  CommonModalWrapperComponent
} from "@shared/components/commons/common-modal-wrapper/common-modal-wrapper.component";
import { InputComponent } from "@shared/controls/input/input.component";

export interface IEditStringModalConfig {
  modalHeader?: string;
  modalIcon?: string;

  controlInitialValue?: string | null;
  controlLabel?: string;
  controlPlaceholder?: string;
  controlHelperText?: string;
  controlCustomErrors?: Record<string, string>;

  confirm: (controlValue: string | null) => Observable<unknown>;
  validators: ValidatorFn[];
  isControlValid: (control: FormControl<string | null>) => boolean;
  responseError?: string;
}

@Component({
  selector: 'app-edit-string-modal',
  standalone: true,
  imports: [
    CommonModalWrapperComponent,
    InputComponent,
    ReactiveFormsModule
  ],
  templateUrl: 'edit-string-modal.component.html',
})
export class EditStringModalComponent implements OnInit {
  activeModal = inject(NgbActiveModal);
  toastr = inject(ToastrService);

  @Input() config!: IEditStringModalConfig;

  isLoading = signal<boolean>(false);
  control = new FormControl<string | null>(null);

  ngOnInit(): void {
    if (!this.config) {
      this.close();
      throw new Error('No config passed');
    }

    this.control.setValue(this.config.controlInitialValue ?? null);

    if (this.config.validators.length) {
      this.control.addValidators(this.config.validators);
    }
  }

  submit(): void {
    if (!this.config.isControlValid(this.control)) {
      this.control.markAsTouched();
      return;
    }

    this.isLoading.set(true);
    this.config.confirm(this.control.value)
      .subscribe({
        next: () => this.activeModal.close(this.control.value),
        error: (error) => {
          console.warn('[EditStringModalComponent] error: ', error);
          this.toastr.error(this.config.responseError ?? 'Error happen', 'Error');
        }
      });
  }

  close(): void {
    this.activeModal.dismiss();
  }
}
